import PropTypes from "prop-types";
import React, { Component } from "react";

import {
  Button,
  Container,
  Icon,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility
} from "semantic-ui-react";

import MenuItems from "../components/MenuItems";
import Gallery from "../components/Gallery";

import * as CONSTANTS from "../assets/Constants";
import Footer from "../components/Footer";

let displayRecruitment = CONSTANTS.displayRecruitment;

const getWidth = () => {
  const isSSR = typeof window === "undefined";
  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth;
};

class DesktopNav extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <Segment
            inverted
            textAlign="center"
            style={{
              padding: "1em 0em",
              backgroundColor: "#111111"
            }}
            vertical
          >
            <Menu
              activeIndex={3}
              fixed={fixed ? "top" : null}
              inverted={!fixed}
              pointing={!fixed}
              secondary={!fixed}
              size="large"
            >
              <MenuItems
                fixed={fixed}
                activeItem="gallery"
                displayRecruitment={displayRecruitment}
              />
            </Menu>
          </Segment>
        </Visibility>
        {children}
      </Responsive>
    );
  }
}

DesktopNav.propTypes = {
  children: PropTypes.node
};

class MobileNav extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation="push"
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <MenuItems
            fixed={false}
            activeItem="gallery"
            displayRecruitment={displayRecruitment}
          />
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign="center"
            style={{
              padding: "1em 0em",
              backgroundColor: "#111111"
            }}
            vertical
          >
            <Container>
              <Menu inverted pointing secondary size="large">
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name="sidebar" />
                </Menu.Item>
                <Menu.Item position="right">
                  <Button as="a" href="#/login" inverted>
                    Log in
                  </Button>
                </Menu.Item>
              </Menu>
            </Container>
            <div />
          </Segment>
          {children}
        </Sidebar.Pusher>
      </Responsive>
    );
  }
}

MobileNav.propTypes = {
  children: PropTypes.node
};

const ResponsiveContainer = ({ children }) => (
  <div>
    <DesktopNav>{children}</DesktopNav>
    <MobileNav>{children}</MobileNav>
  </div>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node
};

const GalleryView = () => (
  <ResponsiveContainer>
    <Gallery />
    <Footer />
  </ResponsiveContainer>
);

export default GalleryView;
